import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';

import ListItemPbxQueue from 'flow/components/ui-components/ListItemPbxQueue';
import useAppContext from 'flow/hooks/useAppContext';
import { routes } from 'flow/types/routes';
import CentralSwitchEmptyState from 'flow/components/central-switch/CentralSwitchEmptyState';
import CentralSwitchHeader from 'flow/components/central-switch/CentralSwitchHeader';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectFavoriteQueuesSortingDataSorted } from 'flow/selectors/queue-selectors';

const FavoritePbxCentralSwitchWidget = () => {
    const { i18next } = useAppContext();
    const history = useHistory();

    const queues = useAppSelector(selectFavoriteQueuesSortingDataSorted);

    const lockScroll = {
        scroll: document.querySelector('#central-switch-overview'),
        wrapper: document.querySelector('#central-switch-overview'),
    };

    return (
        <>
            <CentralSwitchHeader>
                {i18next.t('central_switch.favorite_pbx.description')}
            </CentralSwitchHeader>

            {queues.size > 0 ? (
                <main>
                    <ul className="px-4 pb-4">
                        {queues
                            .take(10)
                            .map((queue) => (
                                <ListItemPbxQueue
                                    key={queue.get('key')}
                                    itemKey={queue.get('key')}
                                    onClick={() =>
                                        history.push(
                                            generatePath(
                                                routes['pbx.queues.entityKey'],
                                                {
                                                    entityKey: queue.get('key'),
                                                },
                                            ),
                                        )
                                    }
                                    lockScroll={lockScroll}
                                    enableCallButton={true}
                                />
                            ))
                            .toArray()}
                    </ul>
                </main>
            ) : (
                <CentralSwitchEmptyState uniqueId={'FavoritePbx'} />
            )}

            {queues.size >= 10 ? (
                <button
                    type="button"
                    className="text-link me-4 h-6 border-none bg-transparent p-0 text-end text-sm"
                    onClick={() => history.push(routes['pbx'])}
                >
                    {i18next.t('show.all')}
                </button>
            ) : null}
        </>
    );
};

export default FavoritePbxCentralSwitchWidget;
